import { l } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { contentManagementSelectors } from 'apps/cms/store'
import { useFlowValidation } from 'common/hooks/useFlowValidation'
import { FsFlow } from 'shared/api/requests/cms/schemas'

export const useFlowCardValidation = (flow: FsFlow) => {
  const { disableFlowCard } = useAppSelector(contentManagementSelectors.getUi)
  const { isValid, errorMessage } = useFlowValidation(flow)
  const isQuickAutomationDisabled = disableFlowCard && flow.is_quick_automation

  return {
    isCardDisabled: !isValid || isQuickAutomationDisabled,
    errorMessage: isQuickAutomationDisabled
      ? l.translate('Quick Automations aren’t available to choose here.')
      : errorMessage,
  }
}
